import { DollarAmount } from '@strata/react-dollar-amount';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { BaseNotification, type NotificationBaseProps } from '@strata/react-notifications';
import { useNavigate } from 'react-router';

import { AppRoutes } from 'services/routes';

export interface NewValueCaseNotificationProps extends NotificationBaseProps {
    linkingId: string;
    patientName: string;
    productName: string;
    valueCaseName: string;
    timestamp: string;
    additionalData?: {
        incentive?: number;
    };
}

export const NewValueCaseNotification = ({
    linkingId,
    patientName,
    productName,
    valueCaseName,
    timestamp,
    additionalData = {},
    onNotificationClick,
    onRemoveNotificationClick,
    status,
}: NewValueCaseNotificationProps) => {
    const navigate = useNavigate();
    const incentive = additionalData?.incentive;
    const incentivePair =
        incentive != null && incentive > 0 ? (
            <DetailLabelValuePair
                label="Incentive"
                value={<DollarAmount amount={incentive} hideCents />}
            />
        ) : null;
    const details = (
        <div className="flex__gap--large">
            <DetailLabelValuePair label="Patient" value={patientName} />
            <DetailLabelValuePair label="Product" value={productName} />
            <DetailLabelValuePair label="Value Case" value={valueCaseName} />
            {incentivePair}
        </div>
    );

    return (
        <BaseNotification
            notificationTitle="New Value Case Received"
            bodyText="A new value case has been added to this referral."
            timestamp={timestamp}
            onNotificationClick={() => {
                onNotificationClick();
                navigate({
                    pathname: AppRoutes.wonReferralDetails(linkingId),
                    hash: 'performance',
                });
            }}
            onRemoveNotificationClick={onRemoveNotificationClick}
            type={BaseNotification.Types.INFO}
            status={status}
            additionalData={details}
        />
    );
};
